import {ChangeDetectionStrategy, Component, Input} from '@angular/core'
import {Offerings} from '../pro-directory-page.types'
import {LinkService} from '../../../../core/i18n/link.service'
import {PUBLIC_ROUTES} from '../../../../shared/routing/public.routes'

@Component({
  selector: 'bgo-sidenav-offerings',
  templateUrl: './sidenav-offerings.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [
    `
      :host {
        display: block;
      }
    `,
  ],
  standalone: false,
})
export class SidenavOfferingsComponent {
  @Input() offerings: Offerings | null = []

  constructor(protected readonly linkService: LinkService) {}

  protected readonly APPLICATION_ROUTES = PUBLIC_ROUTES
}
